export const generateDataLabelPluginConfig = (dataSource) => {
  return {
    afterDraw: function (chartInstance) {
      const ctx = chartInstance.chart.ctx;

      const xScale =
        (chartInstance.scales && (chartInstance.scales['x-axis-0'] || chartInstance.scales['x-axis-1'])) ||
        Object.values(chartInstance.scales || {})[0];

      if (!xScale || !xScale.ticks || !xScale.getPixelForTick) return;

      const { bottom } = chartInstance.chartArea;

      ctx.save();
      ctx.font = '10px Arial';
      ctx.fillStyle = '#236BFF';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'top';

      xScale.ticks.forEach((_, index) => {
        const x = xScale.getPixelForTick(index);
        const val = dataSource[index];
        if (typeof val === 'number' && !isNaN(val)) {
          ctx.fillText(`(${(val / 1000000).toFixed(1)} MM)`, x, bottom + 30);
        }
      });

      ctx.restore();
    },
  };
}